import { render, staticRenderFns } from "./listtsxiansuo.vue?vue&type=template&id=4abf62e1&scoped=true&"
import script from "./listtsxiansuo.vue?vue&type=script&lang=js&"
export * from "./listtsxiansuo.vue?vue&type=script&lang=js&"
import style0 from "./listtsxiansuo.vue?vue&type=style&index=0&id=4abf62e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abf62e1",
  null
  
)

export default component.exports